import { useContext, useEffect } from "react";
import PageTitleContext from "../context/PageTitleContext";


export default function usePageTitle(title?: string): {pageTitle: string, setPageTitle: (title: string) => void} {
    const value = useContext(PageTitleContext)
    useEffect(() => {title && value.setPageTitle(title)}, [title, value]);    
    return value
}